
import Vue from 'vue';
import { Component, Emit } from 'nuxt-property-decorator';
import themeStore from '@/store/theme.store';
@Component({})
export default class ToolsMenu extends Vue {
  fav!: boolean = true;

  get appIsScrolled(): boolean {
    return themeStore.appIsScrolled;
  }

  get isBright(): boolean {
    return themeStore.isBright;
  }

  @Emit()
  favClicked(e) {
    this.fav = !this.fav;
    return e;
  }
}
